/**
 * FAZ 5 M5 — CurrencyChip
 *
 * Küçük para birimi seçici (TRY/USD/EUR/GBP).
 * Ürün formu, teklif, fatura, satın alma gibi çoklu-para-birimi noktalarında kullanılır.
 *
 * Kullanım:
 *   <CurrencyChip value={form.purchase_currency} onChange={(v) => setForm({...form, purchase_currency: v})} />
 */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SUPPORTED = [
  { code: "TRY", symbol: "₺", label: "TRY (₺)" },
  { code: "USD", symbol: "$", label: "USD ($)" },
  { code: "EUR", symbol: "€", label: "EUR (€)" },
  { code: "GBP", symbol: "£", label: "GBP (£)" },
];

export const CURRENCY_SYMBOL = {
  TRY: "₺",
  USD: "$",
  EUR: "€",
  GBP: "£",
};

export default function CurrencyChip({
  value = "TRY",
  onChange,
  size = "sm",
  disabled = false,
  testId = "currency-chip",
}) {
  const cur = SUPPORTED.find((c) => c.code === (value || "TRY").toUpperCase()) || SUPPORTED[0];
  const width = size === "sm" ? "w-[92px]" : "w-[110px]";
  return (
    <Select value={cur.code} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        data-testid={testId}
        className={`bg-slate-950 border-slate-700 rounded-sm font-mono text-xs ${width}`}
      >
        <SelectValue>{cur.code}</SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-slate-900 border-slate-800 text-slate-100 rounded-sm">
        {SUPPORTED.map((c) => (
          <SelectItem key={c.code} value={c.code}>
            {c.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
